import { Icon } from '@eventbrite/eds-icon';
import { Trending as TrendingSvg } from '@eventbrite/eds-iconography';
import classNames from 'classnames';
import React from 'react';
import './TrendingSearchesAnchor.scss';

export const TrendingSearchesAnchor = ({
    trendingSearchData,
    containerClassNames = [],
}: {
    trendingSearchData: {
        path?: string;
        text?: object;
    };
    containerClassNames?: string[];
}) => {
    let component = null;

    if (trendingSearchData) {
        const trendingSearchesAnchorClasses = classNames(
            'trending-searches-anchor',
            'eds-align--center',
            ...containerClassNames,
        );

        component = (
            <div
                className={trendingSearchesAnchorClasses}
                data-testid="trending-searches-anchor"
            >
                <a
                    href={trendingSearchData.path}
                    className="eds-text-weight--heavy eds-align--center"
                >
                    <span className="eds-l-mar-right-3">
                        <Icon type={<TrendingSvg />} />
                    </span>
                    {trendingSearchData.text}
                </a>
            </div>
        );
    }

    return component;
};
